/**
 * Engine API
 * Engine API documentation
 *
 * OpenAPI spec version: 0.0.1
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 *//* tslint:disable:no-unused-variable member-ordering */

import {Inject, Injectable, Optional} from '@angular/core';
import { HttpClient, HttpEvent, HttpHeaders, HttpParams, HttpResponse } from '@angular/common/http';

import {Observable} from 'rxjs';

import {SharedFileExtractConf} from '../model/sharedFileExtractConf';

import {BASE_PATH} from '../variables';
import {Configuration} from '../configuration';
import {CustomHttpUrlEncodingCodec} from "../encoder";


@Injectable()
export class EngineSharedFileService {

    protected basePath = 'https://dmp.airiane.com/services/engine';
    public defaultHeaders = new HttpHeaders();
    public configuration = new Configuration();

    constructor(protected httpClient: HttpClient, @Optional() @Inject(BASE_PATH) basePath: string, @Optional() configuration: Configuration) {
        if (basePath) {
            this.basePath = basePath;
        }
        if (configuration) {
            this.configuration = configuration;
            this.basePath = basePath || configuration.basePath || this.basePath;
        }
    }

    /**
     * @param consumes string[] mime-types
     * @return true: consumes contains 'multipart/form-data', false: otherwise
     */
    private canConsumeForm(consumes: string[]): boolean {
        const form = 'multipart/form-data';
        for (const consume of consumes) {
            if (form === consume) {
                return true;
            }
        }
        return false;
    }


    /**
     * Test connexion
     * Test connexion SFTP ou S3
     * @param body
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public checkConfigShared(body: SharedFileExtractConf, observe?: 'body', reportProgress?: boolean): Observable<{
        [key: string]: string;
    }>;
    public checkConfigShared(body: SharedFileExtractConf, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{
        [key: string]: string;
    }>>;
    public checkConfigShared(body: SharedFileExtractConf, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{
        [key: string]: string;
    }>>;
    public checkConfigShared(body: SharedFileExtractConf, observe: any = 'body', reportProgress = false): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling checkConfigShared.');
        }

        let headers = this.defaultHeaders;

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<{ [key: string]: string; }>('post', `${this.basePath}/api/sharedfile/check`,
            {
                body: body,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }

    /**
     * Test connexion
     * Test connexion SFTP ou S3
     * @param body
     * @param xDataStoreID
     * @param typeJob
     * @param idEtl
     * @param observe set whether or not to return the data Observable as the body, response or events. defaults to returning the body.
     * @param reportProgress flag to report request and response progress.
     */
    public checkConfigSharedByEtl(body: SharedFileExtractConf, xDataStoreID: string, typeJob: string, idEtl: string, observe?: 'body', reportProgress?: boolean): Observable<{
        [key: string]: string;
    }>;
    public checkConfigSharedByEtl(body: SharedFileExtractConf, xDataStoreID: string, typeJob: string, idEtl: string, observe?: 'response', reportProgress?: boolean): Observable<HttpResponse<{
        [key: string]: string;
    }>>;
    public checkConfigSharedByEtl(body: SharedFileExtractConf, xDataStoreID: string, typeJob: string, idEtl: string, observe?: 'events', reportProgress?: boolean): Observable<HttpEvent<{
        [key: string]: string;
    }>>;
    public checkConfigSharedByEtl(body: SharedFileExtractConf, xDataStoreID: string, typeJob: string, idEtl: string, observe: any = 'body', reportProgress = false): Observable<any> {

        if (body === null || body === undefined) {
            throw new Error('Required parameter body was null or undefined when calling checkConfigSharedByEtl.');
        }

        if (xDataStoreID === null || xDataStoreID === undefined) {
            throw new Error('Required parameter xDataStoreID was null or undefined when calling checkConfigSharedByEtl.');
        }

        if (typeJob === null || typeJob === undefined) {
            throw new Error('Required parameter typeJob was null or undefined when calling checkConfigSharedByEtl.');
        }

        if (idEtl === null || idEtl === undefined) {
            throw new Error('Required parameter idEtl was null or undefined when calling checkConfigSharedByEtl.');
        }

        let queryParameters = new HttpParams({encoder: new CustomHttpUrlEncodingCodec()});
        if (typeJob !== undefined && typeJob !== null) {
            queryParameters = queryParameters.set('typeJob', <any>typeJob);
        }

        let headers = this.defaultHeaders;
        if (xDataStoreID !== undefined && xDataStoreID !== null) {
            headers = headers.set('X-DataStoreID', String(xDataStoreID));
        }

        // to determine the Accept header
        const httpHeaderAccepts: string[] = [
            'application/json'
        ];
        const httpHeaderAcceptSelected: string | undefined = this.configuration.selectHeaderAccept(httpHeaderAccepts);
        if (httpHeaderAcceptSelected != undefined) {
            headers = headers.set('Accept', httpHeaderAcceptSelected);
        }

        // to determine the Content-Type header
        const consumes: string[] = [
            'application/json'
        ];
        const httpContentTypeSelected: string | undefined = this.configuration.selectHeaderContentType(consumes);
        if (httpContentTypeSelected != undefined) {
            headers = headers.set('Content-Type', httpContentTypeSelected);
        }

        return this.httpClient.request<{
            [key: string]: string;
        }>('post', `${this.basePath}/api/sharedfile/check/etl/${encodeURIComponent(String(idEtl))}`,
            {
                body: body,
                params: queryParameters,
                withCredentials: this.configuration.withCredentials,
                headers: headers,
                observe: observe,
                reportProgress: reportProgress
            }
        );
    }
}
